'use client';
import e$1 from 'prop-types';
import * as e from 'react';
import t from 'tiny-warning';
import { useComponentStylesLoaded } from '../../hooks/use-component-styles-loaded.js';
import { TabsContext } from './tabs.context.js';
import { useDidImmutableValueChange } from '../../hooks/use-did-immutable-value-change.js';
import { useMap } from '../../hooks/use-map.js';
import { deprecatedProp } from '../core/deprecated-prop.js';
import { renderWithRef } from '../core/render-with-ref.js';
import { SWAN_STYLE_KEY_MAP } from '../head/stylesheets.component.js';
import { useControllableValue } from '../../hooks/use-controllable-value.js';
import { useId } from '../../hooks/use-id.js';
import { RenderComp } from '../core/render-comp.component.js';

let u = {
    centerHeaders: e$1.bool,
    stickyHeaders: e$1.bool,
    wrapHeaders: deprecatedProp(e$1.bool, 'Use the default scrolling behaviour of Tabs instead.'),
    showDividingLine: e$1.bool,
    defaultSelectedTabId: e$1.string,
    selectedTabId: e$1.string,
    onRequestTabChange: e$1.func
}, f = Object.keys(u);
const Tabs = renderWithRef('Tabs', u, (e$1, o)=>{
    useComponentStylesLoaded('Tabs', SWAN_STYLE_KEY_MAP.tabs);
    let { children: s, centerHeaders: u = !1, stickyHeaders: m = !1, wrapHeaders: h = !1, showDividingLine: T = !0, defaultSelectedTabId: w, selectedTabId: v, onRequestTabChange: y } = e$1, g = new Set([
        'swan-vanilla-ignore',
        'swan-tabs'
    ]);
    u && g.add('swan-tabs-center-headers'), m && g.add('swan-tabs-sticky-headers'), h && g.add('swan-tabs-wrap-headers'), !1 === T && g.add('swan-tabs-no-dividing-line');
    let I = void 0 !== v;
    t(!useDidImmutableValueChange(I), I ? 'The `Tabs` component switched from "Uncontrolled" to "Controlled". This is an unsupported pattern. This can happen if `selectedTabId` was not initially defined, but was defined in a subsequent render' : 'The `Tabs` component switched from "Controlled" to "Uncontrolled". This is an unsupported pattern. This can happen if `selectedTabId` was initially defined, but not defined in a subsequent render. If you\'re trying to make it so that _no_ tab is selected, you should pass `null` for `selectedTabId`'), t(I || void 0 !== w, '`defaultSelectedTabId` is required if `selectedTabId` is not provided. If you really want there to be _no_ tab selected initially, pass `null` for `defaultSelectedTabId`');
    let [C, { set: k, remove: q }] = useMap(), [R, { set: S, remove: _ }] = useMap(), [H, { set: U, remove: x }] = useMap(), [E, O] = useControllableValue({
        value: v,
        onChange: y || void 0,
        defaultValue: null != w ? w : null,
        defaultOnChange: (e, ...t)=>{
            let [a] = t;
            e(a);
        }
    }), j = useId();
    return e.createElement(TabsContext.Provider, {
        value: {
            tabsName: j,
            selectedTabId: E,
            onRequestTabChange: O,
            headerIds: C,
            registerHeader: k,
            unregisterHeader: q,
            labelIds: R,
            registerLabel: S,
            unregisterLabel: _,
            contentIds: H,
            registerContent: U,
            unregisterContent: x
        }
    }, e.createElement(RenderComp, {
        root: "div",
        forwardedRef: o,
        propKeysToRemove: f,
        classNames: g,
        props: e$1
    }, s));
});

export { Tabs };
